import SktContentList from './SktContentList';
import SktContentCreate from './SktContentCreate';
import SktContentEdit from './SktContentEdit';

export default {
  list: SktContentList,
  create: SktContentCreate,
  edit: SktContentEdit,
};
